import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Hero, Features, Services, Testimonials } from '../components/sections';
import SupportMission from '../components/sections/SupportMission';
import Newsletter from '../components/sections/Newsletter';

const Home = () => {
  useEffect(() => {
    document.title = 'Pragyavan Wellness Centre - Meditation, Movement & Mindful Living';
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Hero Section */}
      <Hero />
      
      {/* Features Section */}
      <Features />
      
      {/* Services Section */}
      <Services />
      
      {/* Support Mission Section */}
      <SupportMission />
      
      {/* Testimonials Section */}
      <Testimonials />
      
      {/* Newsletter Section */}
      <Newsletter />
    </motion.div>
  );
};

export default Home;